import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useGlobals } from "../../hooks/useGlobals";

const Footers = styled.div`
  width: 100%;
  height: 590px;
  display: flex;
  background: #343434;
  background-size: cover;
`;

export default function Footer() {
  const { authMember } = useGlobals();

  return (
    <Footers>
      <Container>
        <Stack flexDirection={"row"} sx={{ mt: "94px" }}>
          <Stack flexDirection={"column"} style={{ width: "340px" }}>
            <Box>
              <p className={"logo"}>BEAUTIFY</p>
            </Box>
            <Box className={"foot-desc-txt"}>
              Whether it's for your hygiene or beauty regimen, cosmetic products
              are a big part of your daily life. Learn about them and how to be
              a smart consumer.
            </Box>
            <Box className="sns-context">
              <img src={"/icons/facebook.svg"} alt="" />
              <img src={"/icons/twitter.svg"} alt="" />
              <img src={"/icons/instagram.svg"} alt="" />
              <img src={"/icons/youtube.svg"} alt="" />
            </Box>
          </Stack>
          <Stack sx={{ ml: "288px" }} flexDirection={"row"}>
            <Stack>
              <Box>
                <Box className={"foot-category-title"}>GoPages</Box>
                <Box className={"foot-category-link"}>
                  <Link to="/">Home</Link>
                  <Link to="/products">Products</Link>
                  {authMember && <Link to="/orders">Orders</Link>}
                  <Link to="/help">Help</Link>
                </Box>
              </Box>
            </Stack>
            <Stack sx={{ ml: "200px" }}>
              <Box>
                <Box className={"foot-category-title"}>Find us</Box>
                <Box
                  flexDirection={"column"}
                  sx={{ mt: "20px" }}
                  className={"foot-category-link"}
                  justifyContent={"space-between"}
                >
                  <Box flexDirection={"row"} className={"find-us"}>
                    <span>Location:</span>
                    <div>Downtown, London </div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>Phone:</span>
                    <div>+971 4 554 7777</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>Email:</span>
                    <div>jutrading@gmail.com</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>Hours:</span>
                    <div>Visit 24 hours</div>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          style={{ border: "1px solid #C5C8C9", width: "100%", opacity: "0.2" }}
          sx={{ mt: "80px" }}
        ></Stack>
        <Stack className={"copyright-txt"}>
          © Copyright JUTrading, All rights reserved.
        </Stack>
      </Container>
    </Footers>
  );
}
